import React from 'react';
import { MaintenanceDatePicker } from '../../../GenericComponents';
import { Field } from 'react-final-form';
import { useTranslation } from '../translationContext';

const marginTop = '10px';

export const dateRangeFieldNames = field => {
  return [`${field}Start`, `${field}End`];
};

const TableFilterDatePicker = ({ field, inputRef, onChange }) => {
  const { t } = useTranslation();
  return (
    <>
      {dateRangeFieldNames(field).map((fieldRangeName, index) => {
        const isFirst = index === 0;
        return (
          <div key={fieldRangeName} style={isFirst ? { marginTop } : {}}>
            <Field
              key={fieldRangeName}
              name={fieldRangeName}
              component={MaintenanceDatePicker}
              className={isFirst ? 'mb-3' : ''}
              labels={t("tablefilter")}
              ariaLabel={t(`tablefilter.defaultplaceholder.${fieldRangeName}`)}
              forwardRef={true}
              ref={isFirst ? inputRef : undefined}
              onChange={onChange}
              isSearch
            />
          </div>
        );
      })}
    </>
  );
};

export default TableFilterDatePicker;
